module.exports = "/assets/data/dcbab2505faf71de23773043a1c09a8d-ME9.data.json";